import {
  EMBEDDED_LOGIN_SUCCESS_EVENT,
  IS_EMBEDDED_QUERY_PARAM,
} from 'constants/appConstants';

export const IS_EMBEDDED_LOGIN_KEY = 'isEmbeddedLogin';

export const isAppEmbedded = () =>
  window.location.search?.includes(IS_EMBEDDED_QUERY_PARAM);

export const isLoggingInToEmbeddedApp = () =>
  !!window.opener && sessionStorage.getItem(IS_EMBEDDED_LOGIN_KEY) === 'true';

export const openPageInNewTab = (url: string) =>
  window?.open(url, '_blank')?.focus();

export const notifyLoginSuccessToParentAndClose = () => {
  window.opener.postMessage(
    {
      type: EMBEDDED_LOGIN_SUCCESS_EVENT,
    },
    '*'
  );
  window.close();
};
